import { Component, AfterViewInit, ChangeDetectionStrategy, signal, inject, DOCUMENT } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BrandsDialogComponent } from './brands-dialog/brands-dialog.component';
import { IBrandCard } from '../../types';
import { HomeService } from './home.service';
import { BannerComponent } from './banner/banner.component';
import { MatIcon } from '@angular/material/icon';
import { VideoBannerComponent } from './video-banner/video-banner.component';
import { BrandCarouselComponent } from '../brand-carousel/brand-carousel.component';
import { LocationService } from '../../location.service';
@Component({
  selector: 'cloudigo-homev2',
  templateUrl: './homev2.component.html',
  styleUrls: ['./homev2.component.scss'],
  standalone: true,
  imports: [BannerComponent, MatIcon, VideoBannerComponent, BrandCarouselComponent],
  providers: [HomeService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.home]': 'document.location.pathname == "/"'
  }
})

export default class Homev2Component {
  document = inject(DOCUMENT);
  home = inject(HomeService);
  router = inject(LocationService);
  dialog = inject(MatDialog);

  brands = signal<IBrandCard[]|null>([]);
  reviews = [{ "reviewer": "Martina F.", "message": "\"I don’t like to save money - said no one ever! cloudigo is the best virtual discount card one can invest in.\"" },
  { "reviewer": "Elisa D.", "message": "\"Love using the friendly app, love going shopping and for lunches knowing I’m getting a Good deal.\"" },
  { "reviewer": " Elaine S.", "message": "\"Very easy to use app and efficient! Good offers and choice of shops and restaurants! Worth every penny.\"" },
  { "reviewer": "Caroline G.", "message": "\"Have saved so much money with cloudigo! The app is so easy to use, and so convenient to carry around!\"" },
  { "reviewer": "Rebecca S.", "message": "\"All the best discounts? There's only one app that has them! cloudigo!\"" },
  ];

  constructor() { 
    this.home.getFeaturedBrands().subscribe({
      next: brands => {
        this.brands.set(brands || []);
      },
      error: error => {
        error = error.error||error;
        console.warn('Failed to load brands', error.message);
        this.brands.set(null);
          // this.ss.auth.handleResponseError(error, undefined, () => this.ngOnInit(), false);
        }
    });

  }

  referRegistration() {
    this.router.navigate(['/login']);
  }

  referDownload() {
    this.router.navigate(['/get-the-app']);
  }

  seeBrands() {
    this.dialog.open(BrandsDialogComponent, {
      height: "85vh",
      maxWidth: '90vw',
      width: '800px',
      autoFocus: false
    });
  }
}
